import { Component, ElementRef, ViewChild, AfterViewInit, OnInit, ComponentFactoryResolver } from '@angular/core';
import { LoginService } from './login/login.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import { NgPipesModule } from 'ngx-pipes';

import { TabGroup, Datepicker, Select, Dropdown, Menu, Tree } from '@eds/vanilla';

import { commonDataService } from '../../projects/dashboard/src/app/service/commonUsage.data.service';
import { userUsageDataService } from '../../projects/dashboard/src/app/service/userUsage.data.service';
import { deviceUsageDataService } from '../../projects/dashboard/src/app/service/deviceUsage.data.service';
import { applicationUsageDataService } from '../../projects/dashboard/src/app/service/applicationUsage.data.service';
import { learningContentDataService } from '../../projects/dashboard/src/app/service/contentUsage.data.service';
import { forEach } from 'underscore';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [LoginService]
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'ctl-sm-portal';
  route: string;
  selectedTimePeriod = 'Last year';
  selectedTimePeriodStr = "Last year"
  public dateField: any;

  @ViewChild('tabs') tabs: ElementRef;
  @ViewChild('tree') elTrees: ElementRef;
  @ViewChild('usertree') elUserTrees: ElementRef;

  isSecificDateVisible: boolean;
  timePeriodArr = [
    {id: '24Hours', name: 'Last 24 Hours'},
    {id: '7Days', name: 'Last 7 days'},
    {id: '30Days', name: 'Last 30 days'},
    {id: '90Days', name: 'Last 90 days'},
    {id: 'Year', name: 'Last year'},
    {id: 'Year', name: 'All time'},
    {id: 'Specify dates', name: 'Specify dates'}
  ];

  userUsageData;
  isNaN: Function = Number.isNaN;

  username: string;
  loggedInUser: any;
  selectedFromdate: any;
  selectedToDate: any;
  getFromDateFormat: string;
  getToDateFormat: string;

  selectedProject: any;
  selectedCountry: any;
  selectedSchool: any;
  selectedGrade: any;
  selectedClass: any;
  selectedRole: any; 
  selectedGender: any;

  selectAllCountry: any;
  selectAllProject: any;
  selectAllSchool: any;
  selectAllGrade: any;
  selectAllClass: any;

  countryListData: any = [];
  projectListData: any = [];
  schoolListData: any = [];
  gradesListData: any = [];
  classesListData: any = [];
  genderListData:any = [];
  userTypeListData: any = [];
  userGenderListData: any = [];
  filteredData:any = [];
userCountryList:any = [];
  projectTree: any;
  groupedProjectData: any = [];
  groupedGradeData: any = [];
  countryIndex: any;
  projectIndex: any;
  schoolIndex: any;
  gradeIndex: any;

  teacherCount=0;
  studentCount=0;
  adminCount=0;
  femaleCount = 0;
  maleCount = 0;
  groupedUsersCountData: any = [];
  selectedCountryProject: any = [];
  selectedProjectGrades: any = [];
  selectedSchoolClasses: any = [];

  getDate: any = [];


  // getFormatted
  countryId: any;
  projectId: any;
  isFiltered = false;
  isUserFiltered = false;
  isTimeperiedSelected = false;
  edsInitiated = false;
  edsCalled = false;
 initCount = 0;
 userProjID:any;
 fistTimeLoaded = false;
  currentTab: any;
  otherFilter: any = {};
  isDashInit = false;
  routeVisitUser: string;
  routeVisitUserId : string;
  textDir:any;
  constructor(
    location: Location,
    private router: Router,
    private routeAct: ActivatedRoute,
    private commonDataService: commonDataService,
    private userUsageDataService: userUsageDataService,
    private deviceUsageDataService: deviceUsageDataService,
    private applicationUsageDataService: applicationUsageDataService,
    private contentUsageDataService: learningContentDataService
    ) {
      router.events.subscribe(val => {
        const curUrl = location.path();
        const curUrlArr = curUrl.split('/');
        this.route = curUrlArr[1];
        if (this.route === 'dashboard'){
          const userData = JSON.parse(window.localStorage.getItem('loginInfoObj'));                    
          if (userData) {
            if(this.routeVisitUserId != userData._id){ 
               
              if (userData.role.name === 'GeneralAdmin') {
                this.commonDataService.listProjects();
              } else if ( userData.role.name === 'ProjectAdmin') {
                  this.commonDataService.getProject(userData.project._id);
              } else if ( userData.role.name === 'SchoolAdmin') {
                this.commonDataService.getProject(userData.project._id);
                this.schoolListData = userData.school;
                this.commonDataService.listGrade(userData.school._id);
              }
              this.routeVisitUser = userData.role.name;
              this.routeVisitUserId = userData._id;
              this.clearOthers();
              this.getProjectList();  
              this.getCountryList();
              this.clearAllFilterAtInit();
              this.selectTimePeriod("7Days", "Last 7 days") 
            }            
          }
          if((!this.edsInitiated && !this.edsCalled)){
            setTimeout(() => this.edsComponentInit() , 100);
            this.edsCalled = true;
            this.edsInitiated = true;
          }else if(!this.edsInitiated){
            setTimeout(() => this.edsComponentInit() , 100);
            this.edsInitiated = true;
          }    
      
        }else{
          // this.otherFilter = {};
          this.edsInitiated = false;
          this.clearAllFilterAtInit();
        }
      });
     /*  const LoginuserData = JSON.parse(window.localStorage.getItem('loginInfoObj'));
      if(LoginuserData){
        
        this.loggedInUser = LoginuserData;
        console.log("this.loggedInUser 2>>> ");
        console.log(this.loggedInUser)
       
      } */
      this.textDir = sessionStorage.getItem('textDir');
  }
  ngOnInit() {
    const userData = JSON.parse(window.localStorage.getItem('loginInfoObj'));
    if (userData) {
      this.loggedInUser = userData;
      this.username = this.loggedInUser.first_name;
      
     /*  if (userData.role.name === 'GeneralAdmin') {
          this.commonDataService.listProjects();
      } else if ( userData.role.name === 'ProjectAdmin') {
        // if (this.route === 'dashboard'){
          if(this.loggedInUser.project){
            this.userProjID = this.loggedInUser.project._id;
            this.commonDataService.getProject(this.userProjID);           
          }
        
      } else if ( userData.role.name === 'SchoolAdmin') {
        this.commonDataService.getProject(userData.project._id);
        this.schoolListData = userData.school;
        this.commonDataService.listGrade(userData.school._id);
      } */
      this.teacherCount=0;
      this.studentCount=0;
      this.adminCount=0;
     /*  this.getProjectList();  
      this.getCountryList();  */
      //this.groupedUsersCountData.push({teacher:0, student:0, admin:0})
    }

  }

  ngAfterViewInit() {
    this.currentTab = 'overview';
  }

  edsComponentInit(){
    this.edsInitiated = true;
    this.tabInit();
    this.selectInit();
    this.datePickerInit();
    this.treeInit();
    this.isSecificDateVisible = false;    
  }
  tabInit(){
    const tabs = document.querySelectorAll('.tabs');
    if (tabs) {
      Array.from(tabs).forEach(tabGroup1 => {
        const tabGroup = new TabGroup(tabGroup1 as HTMLElement);
        tabGroup.init();
      });
    }
  }

  selectInit(){
    // console.log('Select INIT');
    const selects = document.querySelectorAll('.select');
    if (selects) {
      Array.from(selects).forEach((select1) => {
        const select = new Select(select1 as HTMLElement);
        select.init();
        this.dateField = select;
      });
    }
  }

  datePickerInit(){
    // console.log('DatePicker initiated');
    const datepickers = document.querySelectorAll('.datepickerFrom');
    if (datepickers) {
      Array.from(datepickers).forEach((datepicker1) => {
        const datepicker = new Datepicker(datepicker1 as HTMLElement);
        datepicker.init();
        this.selectedFromdate = datepicker;
      });
    }
    const datepickers2 = document.querySelectorAll('.datepickerTo');
    if (datepickers) {
      Array.from(datepickers2).forEach((datepicker2) => {
        const datepickerI2 = new Datepicker(datepicker2 as HTMLElement);
        datepickerI2.init();
        this.selectedToDate = datepickerI2;
      });
    }
  }

  treeInit(){
    const trees = document.querySelectorAll('.tree');
    if (trees) {
      Array.from(trees).forEach(tree1 => {
        const tree = new Tree(tree1 as HTMLElement);
        tree.init();
        this.projectTree = tree;
      });
    }

    const userTrees = document.querySelectorAll('.tree1');
    if (trees) {
      Array.from(userTrees).forEach(utree1 => {
        const utree = new Tree(utree1 as HTMLElement);
        utree.init();
      });
    }
  }
selectDropdown(){
  console.log("dropdown clicked")
}
  selectTimePeriod(val, name){
   console.log(val+" : "+name)
    if (val === 'Specify dates'){
      this.isSecificDateVisible = true;
      return;
    }else{
      this.isSecificDateVisible = false;
    }
    this.isFiltered = true;
    this.isUserFiltered = true;
    this.isTimeperiedSelected = true;
    this.selectedTimePeriod = val;  
    this.selectedTimePeriodStr = name;   
    this.userUsageDataService.setDateFilter(val);    
    this.deviceUsageDataService.setDateFilter(val);
    this.applicationUsageDataService.setDateFilter(val);
    this.contentUsageDataService.setDateFilter(val);
    
    this.loadRawData();
   //this.getGenderList();   
    this.getUsersList();
    this.router.navigate(['/dashboard/', this.currentTab]);
  }

  closeAllMenu(){
    if (this.selectAllCountry && this.selectAllCountry.event) {
      this.selectAllCountry.event.target.classList.remove('opened');
    }
    if (this.selectAllProject && this.selectAllProject.event) {
      this.selectAllProject.event.target.classList.remove('opened');
    }
    if (this.selectAllSchool && this.selectAllSchool.event) {
      this.selectAllSchool.event.target.classList.remove('opened');
    }
    if (this.selectAllGrade && this.selectAllGrade.event) {
      this.selectAllGrade.event.target.classList.remove('opened');
    }
    if (this.selectAllClass && this.selectAllClass.event) {
      this.selectAllClass.event.target.classList.remove('opened');
    }
  }

  clearOthers() {
      this.closeAllMenu();
    this.otherFilter = {};
    this.isFiltered = false;
  
    if (this.selectedProject && this.selectedProject.event) {
      this.selectedProject.event.target.classList.remove('active');
    }
    if (this.selectedCountry && this.selectedCountry.event) {
      this.selectedCountry.event.target.classList.remove('active');
    }
    if (this.selectedSchool && this.selectedSchool.event) {
      this.selectedSchool.event.target.classList.remove('active');
    }
    if (this.selectedGrade && this.selectedGrade.event) {
      this.selectedGrade.event.target.classList.remove('active');
    }
    if (this.selectedClass && this.selectedClass.event) {
      this.selectedClass.event.target.classList.remove('active');
    }
    

    this.selectedProject = {};
    this.selectedCountry = {}
    this.selectedSchool = {};
    this.selectedGrade = {};
    this.selectedClass = {};
    this.selectedProject = undefined;
    this.selectedCountry = undefined;
    this.selectedSchool = undefined;
    this.selectedGrade = undefined;
    this.selectedClass = undefined;
    this.schoolListData = [];
    this.gradesListData = [];
    this.classesListData = [];
    this.otherFilter = {};
    this.getProjectList();
    this.setOtherClearFilters();
  }
  clearUserSection(){
    delete this.otherFilter.role;
    delete this.otherFilter.gender_id;

   
    this.isUserFiltered = false;
    if (this.selectedRole && this.selectedRole.event) {
      this.selectedRole.event.target.classList.remove('active');
    }
    if (this.selectedGender && this.selectedGender.event) {
      this.selectedGender.event.target.classList.remove('active');
    }
    this.selectedRole = {};
    this.selectedGender = {};
    this.selectedRole = undefined;
    this.selectedGender = undefined;
    this.setOtherClearFilters();
  }
  setOtherFilters() {
    //this.find_in_object(this.filteredData)
    this.userUsageDataService.setOtherFilter(this.otherFilter);
    this.deviceUsageDataService.setOtherFilter(this.otherFilter);
    this.applicationUsageDataService.setOtherFilter(this.otherFilter);
    this.contentUsageDataService.setOtherFilter(this.otherFilter);
    this.isFiltered = true;
    this.isUserFiltered = true;
    this.gotoTab(this.currentTab);
  }
  setOtherClearFilters() {
    this.userUsageDataService.setOtherFilter(this.otherFilter);
    this.deviceUsageDataService.setOtherFilter(this.otherFilter);
    this.applicationUsageDataService.setOtherFilter(this.otherFilter);
    this.contentUsageDataService.setOtherFilter(this.otherFilter);
    this.gotoTab(this.currentTab);
  }

  clearAllFilterAtInit(){
    this.selectedProject = undefined;
    this.selectedCountry = undefined;
    this.selectedSchool = undefined;
    this.selectedGrade = undefined;
    this.selectedClass = undefined;
    this.currentTab = "overview";
    this.selectedTimePeriod = "7Days";
    this.selectedTimePeriodStr = "Last 7 days";
    this.otherFilter = {};
    this.userUsageDataService.setOtherFilter(this.otherFilter);
    this.deviceUsageDataService.setOtherFilter(this.otherFilter);
    this.applicationUsageDataService.setOtherFilter(this.otherFilter);
    this.contentUsageDataService.setOtherFilter(this.otherFilter);
  }

  setDateFilters() {
    this.userUsageDataService.setDateFilter(this.getFromDateFormat, this.getToDateFormat);
    this.deviceUsageDataService.setDateFilter(this.getFromDateFormat, this.getToDateFormat);
    this.applicationUsageDataService.setDateFilter(this.getFromDateFormat, this.getToDateFormat);
    this.contentUsageDataService.setDateFilter(this.getFromDateFormat, this.getToDateFormat);
    //this.loadRawData();
    this.gotoTab(this.currentTab);
  }

  loadRawData() {
    console.log("loadRawData>>>>>>>>>>>>")
    this.userUsageDataService.loadUserUsageData();
    this.deviceUsageDataService.loadDeviceUsageData();
    this.deviceUsageDataService.getDeviceInventoryData();
    this.applicationUsageDataService.loadApplicationUsageData();
    this.applicationUsageDataService.getApplicationInventoryData();
    this.contentUsageDataService.loadContentUsageData();
  }

  getSpecificDates(){
    let frommonthval: any;
    let toMonthVal: any;
    let fromday: any;
    let today: any;

    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];

    let i: number;
    for (i = 0; i < 12; i++){
      if (this.selectedFromdate.selectedDate.month === months[i]){
        // alert(months[i] +"i val = "+i+1))
        if (i < 9){
        frommonthval = '0' + (i + 1);
        } else{
        frommonthval = i + 1;
        }

      }
      if (this.selectedToDate.selectedDate.month == months[i]){
        // alert(months[i] +"i val = "+i+1))
        if (i < 9){
          toMonthVal = '0' + (i + 1);
        } else{
          toMonthVal = i + 1;
        }
      }
    }

    fromday = this.selectedFromdate.selectedDate.day;
    if (fromday < 10) {
      fromday = '0' + fromday;
    }
    today = this.selectedToDate.selectedDate.day;
    if (today < 10) {
      today = '0' + today;
    }

    this.getFromDateFormat = this.selectedFromdate.selectedDate.year + '-' + frommonthval + '-' + fromday;
    this.getToDateFormat = this.selectedToDate.selectedDate.year + '-' + toMonthVal + '-' + today;
    this.getDate = {startdate: this.getFromDateFormat, enddate: this.getToDateFormat}

    this.getProjectList();
    this.setDateFilters();
  }

  gotoTab(name) {
    this.currentTab = name;
    this.router.navigate(['/dashboard/', name]);
  }

  getSelectedCountry(item: any, event){
    if (!this.selectedCountry || !this.selectedCountry.name) {
      this.selectedCountry = {};
      this.selectedCountry.name = item.name;
      this.filteredData.country_id = item._id;
      this.selectedCountry.event = event;
      event.target.classList.add('active');
    } else if (this.selectedCountry && this.selectedCountry.name === item.name) {
      this.selectedCountry = undefined;
      event.target.classList.remove('active');
    } else {
      this.selectedCountry.name = item.name;
      this.selectedCountry.event.target.classList.remove('active');
      this.selectedCountry.event = event;
      event.target.classList.add('active');
    }
   
      this.schoolListData = [];
      
      this.gradesListData = [];
      this.classesListData = [];
    
    
    this.getProjectList();
    this.setOtherFilters();
  }

  getSelectedProject(item: any, event){
    if (!this.selectedProject || !this.selectedProject._id) {
      this.selectedProject = {};
      this.selectedProject._id = item._id;
      this.filteredData.project_id = this.selectedProject._id;
      this.selectedProject.event = event;
      this.otherFilter.project_id = item._id;
      event.target.classList.add('active');
      this.getSchoolsList(this.selectedProject._id);
      this.getGenderList();
    } else if (this.selectedProject && this.selectedProject._id === item._id) {
      this.selectedProject = undefined;
      delete this.otherFilter.project_id;
      event.target.classList.remove('active');
      this.getSchoolsList();
      this.getGenderList();
    } else {
      this.selectedProject._id = item._id;
      this.otherFilter.project_id = item._id;
      this.selectedProject.event.target.classList.remove('active');
      this.selectedProject.event = event;
      event.target.classList.add('active');
      this.getSchoolsList(this.selectedProject._id);
      this.getGenderList();
    }
   
    this.setOtherFilters();
  }

  getSelectedSchool(item: any, event){
    if (!this.selectedSchool || !this.selectedSchool._id) {
      this.selectedSchool = {};
      this.selectedSchool._id = item._id;

      this.filteredData.school_id = this.selectedSchool._id;
      this.selectedSchool.event = event;
      this.otherFilter.school_id = item._id;
      event.target.classList.add('active');
      this.getGradeList(this.selectedSchool._id);
    } else if (this.selectedSchool && this.selectedSchool._id === item._id) {
      this.selectedSchool = undefined;
      delete this.otherFilter.school_id;
      event.target.classList.remove('active');
      this.getGradeList();
    } else {
      this.selectedSchool._id = item._id;
      this.otherFilter.school_id = item._id;
      this.selectedSchool.event.target.classList.remove('active');
      this.selectedSchool.event = event;
      event.target.classList.add('active');
      this.getGradeList(this.selectedSchool._id);
    }
    
    this.setOtherFilters();
  }

  getSelectedGrade(item: any, event){
    if (!this.selectedGrade || !this.selectedGrade._id) {
      this.selectedGrade = {};
      this.selectedGrade._id = item._id;
      this.filteredData.grade_id = this.selectedGrade._id;
      this.selectedGrade.event = event;
      this.otherFilter.grade_id = item._id;
      event.target.classList.add('active');
      this.getClassList(this.selectedGrade._id);
    } else if (this.selectedGrade && this.selectedGrade._id === item._id) {
      this.selectedGrade = undefined;
      delete this.otherFilter.grade_id;
      event.target.classList.remove('active');
      this.getGradeList();
    } else {
      this.selectedGrade._id = item._id;
      this.otherFilter.grade_id = item._id;
      this.selectedGrade.event.target.classList.remove('active');
      this.selectedGrade.event = event;
      event.target.classList.add('active');
      this.getClassList(this.selectedGrade._id);
    }
    this.setOtherFilters();
  }

  getSelectedClass(item: any, event){
    if (!this.selectedClass || !this.selectedClass._id) {
      this.selectedClass = {};
      this.selectedClass._id = item._id;
      this.filteredData.class_id = this.selectedClass._id;

      this.selectedClass.event = event;
      this.otherFilter.class_id = item._id;
      event.target.classList.add('active');
    } else if (this.selectedClass && this.selectedClass._id === item._id) {
      this.selectedClass = undefined;
      delete this.otherFilter.class_id;
      event.target.classList.remove('active');
    } else {
      this.selectedClass._id = item._id;
      this.otherFilter.class_id = item._id;
      this.selectedClass.event.target.classList.remove('active');
      this.selectedClass.event = event;
      event.target.classList.add('active');
    }
    this.setOtherFilters();
    
  }

  getselectedRole(item: any, event){
  // console.log("selectedRole  >>>> "+item.role._id)
    if (!this.selectedRole || !this.selectedRole.role_id) {
      this.selectedRole = {};
      this.selectedRole.role_id = item.role._id;
      this.selectedRole.event = event;
      this.filteredData.role_id = this.selectedRole.role_id;
      this.otherFilter.role = item.role;
      event.target.classList.add('active');
      this.getClassList(this.selectedRole._id);
    } else if (this.selectedRole && this.selectedRole.role_id === item.role._id) {
      this.selectedRole = undefined;
      delete this.otherFilter.role;
      event.target.classList.remove('active');
      this.getGradeList();
    } else {
      this.selectedRole.role_id = item.role._id;
      this.otherFilter.role = item.role;
      this.selectedRole.event.target.classList.remove('active');
      this.selectedRole.event = event;
      event.target.classList.add('active');
      this.getClassList(this.selectedRole.role_id);
    }
    this.setOtherFilters();
  }
  getSelectedGender(item: any, event){
    // console.log("getSelectedGender  >>>> "+item._id)

    if (!this.selectedGender || !this.selectedGender._id) {
      this.selectedGender = {};
      this.selectedGender._id = item._id;
      this.selectedGender.event = event;
      this.filteredData.gender_id = this.selectedGender._id;
      this.otherFilter.gender_id = item._id;
      event.target.classList.add('active');
      
      console.log("getSelectedGender 1 >>>> "+item._id)
    } else if (this.selectedGender && this.selectedGender._id === item._id) {
      this.selectedGender = undefined;
      delete this.otherFilter.gender_id;
      event.target.classList.remove('active');
      console.log("getSelectedGender 2 >>>> "+item._id)
      
    } else {
      this.selectedGender._id = item._id;
      this.otherFilter.gender_id = item._id;
      this.selectedGender.event.target.classList.remove('active');
      this.selectedGender.event = event;
      event.target.classList.add('active');
      console.log("getSelectedGender 3 >>>> "+item._id)
     
    }
    this.setOtherFilters();
  }

  find_in_object(my_array, my_criteria) {
    return my_array.filter(function(obj) {
      return Object.keys(my_criteria).every(function(key) {
        return (Array.isArray(my_criteria[key]) &&
          (my_criteria[key].some(function(criteria) {
            return (typeof obj[key] === 'string' && obj[key].indexOf(criteria) === -1)
          })) || my_criteria[key].length === 0);
      });
    });
  }


  getAllCountry(item: any, event){
    if (this.selectAllCountry && this.selectAllCountry.event) {
      this.selectAllCountry.event.target.classList.add('active');
    }
  }
  getAllProject(item: any, event){
    if (this.selectAllProject && this.selectAllProject.event) {
      this.selectAllProject.event.target.classList.add('active');
    }
  }
  getAllSchool(item: any, event){
    if (this.selectAllSchool && this.selectAllSchool.event) {
      this.selectAllSchool.event.target.classList.add('active');
    }
  }
  getAllGrade(item: any, event){
    if (this.selectAllGrade && this.selectAllGrade.event) {
      this.selectAllGrade.event.target.classList.add('active');
    }
  }
  getAllClass(item: any, event){
    if (this.selectAllClass && this.selectAllClass.event) {
      this.selectAllClass.event.target.classList.add('active');
    }
  }
  getCountryList() {
    this.commonDataService.countryList$Data.subscribe( data => {
      let newArr;
      if(this.userProjID){

        let projData: any = [];
        projData = [...data];
        let userProjList = projData.filter(item => item._id === this.userProjID);         
        newArr = userProjList;
        let newCountryList = [...this.userCountryList];
        this.countryListData  =  this.removeDuplicates(newArr, 'name');
      //  console.log("CountryList newArr>>>> "+JSON.stringify(newCountryList));

      }else{
        newArr = [...data];
        this.countryListData  =  this.removeDuplicates(newArr, 'name')
      }
      
     
      
      
    });
    //console.log("CountryList >>>> "+JSON.stringify(this.countryListData));
  }

  getProjectList() {
    this.projectListData =[];
    let userprojectlist;
    this.commonDataService.projectList$Data.subscribe( data => {
     /*  console.log('projectlist data >>> ');
      console.log(data); */
      if (this.selectedCountry) {
        const projectlist = data.filter(x => x.country.name === this.selectedCountry.name);
        this.projectListData = [...projectlist];
       // console.log("JANAKI --- projectListData >>>> "+JSON.stringify(this.projectListData.length));
       /*  if(this.userProjID){

          let projData: any = [];
          projData = [...data];
         
          let userProjList = projData.filter(item => item._id === this.userProjID);         
          this.projectListData = userProjList;
          this.userCountryList = this.projectListData; 
         

        }else{
          this.projectListData = [...data];
        } */
      } else {
       
        if(this.userProjID){

          let projData: any = [];
          projData = [...data];
         
          let userProjList = projData.filter(item => item._id === this.userProjID);         
          this.projectListData = userProjList;
          this.userCountryList = this.projectListData; 
         

        }else{
          this.projectListData = [...data];
        }
        
       
       
      }
      //console.log("JANAKI --- projectListData >>>> "+JSON.stringify( this.projectListData.length)+" : "+this.userProjID);
      this.commonDataService.listCountries();
      
    });
  }

  getSchoolsList(projectId?: any) {
    if (projectId) {
      this.commonDataService.listSchools(projectId);
      this.commonDataService.schoolList$Data.subscribe( data => {
        this.schoolListData = [...data];
      });
    } else {
      this.schoolListData = [];
    }
  }
  getGradeList(schoolId?: any) {
    if (schoolId) {
      this.commonDataService.listGrade(schoolId);

      this.commonDataService.gradeList$Data.subscribe( data => {
       // console.log('grade list >>> ' + JSON.stringify(data));
        this.gradesListData = [...data];
      });
    } else {
      this.gradesListData = [];
    }
  }

  getClassList(gradeId: any) {
    if (gradeId) {
      this.commonDataService.listClass(gradeId);
      this.commonDataService.classList$Data.subscribe( data => {
        this.classesListData = [...data];
      });
    } else {
      this.classesListData = [];
    }
  }
  getGenderList() {
    
      //this.commonDataService.listGender(schoolId);
 let fCount;
 let mCount;
 this.commonDataService.listGender();
 this.commonDataService.genderList$Data.subscribe( data => {
  this.genderListData = [...data];
   console.log("genderListData>>>> ");
   console.log(data);

});

this.userUsageDataService.listGender();
      this.userUsageDataService.userUsage$Data.subscribe(data => {
        if(data){
        this.userTypeListData = [...data];
        fCount = 0;
        mCount = 0;
        this.femaleCount = 0;
        this.maleCount = 0;
        this.genderListData = [...data];
        this.userTypeListData.forEach(function (value) {
        
            if(value.gender_id == "5d6d04cea55cc02187efce6b"){
              mCount =mCount+1;   
            }else{
              fCount =fCount+1;      
            }  
           
           //console.log('gender list >>> ' + JSON.stringify( this.genderListData));
         });
         this.femaleCount = fCount;
         this.maleCount = mCount;
        //  console.log('gender list >>> ' + this.femaleCount+" : "+this.maleCount);
      }

      });
    
  }
  getUsersList() {
   
      this.userUsageDataService.listUserType();
      let tCount;
      let sCount;
      let aCount;
      let userDataArr= [];
      console.log("getUsersList>>>");
      this.userUsageDataService.userUsage$Data.subscribe(data => {
        if(data){
        this.userTypeListData = [...data];
        tCount = 0;
        sCount = 0;
        aCount = 0;
        this.teacherCount = 0;
        this.studentCount = 0;
        this.adminCount = 0;

         
        //console.log(this.userTypeListData);  


        let result = this.userTypeListData.reduce(function (a, c) {
          a[c.role.name] = a[c.role.name] || [];
          a[c.role.name].push(c)
          return a;
        }, Object.create(null));
       
       

        let arr = [];  
        Object.keys(result).map(function(key){  
            arr.push({[key]:result[key]})  
            return arr;  
        });  
        this.groupedUsersCountData=[];
        this.groupedUsersCountData = arr;
        // console.log("this.groupedUsersCountData ---JANAKi -- ");

        // console.log(this.groupedUsersCountData);
        this.userTypeListData.forEach(function (value) {
        
         // console.log("Roles ---JANAKi -- "+value.role.name);
            if(value.role.name == 'Teacher'){
              tCount= tCount+1;           
            }
            if(value.role.name == 'Student'){
              sCount=sCount+1;           
            }
            if(value.role.name == 'ProjectAdmin'){
            aCount= aCount+1;            
            }         
          }); 
        }

        this.teacherCount = tCount;
        this.studentCount = sCount;
        this.adminCount = aCount;

        //this.gradesListData = [...data];
        // console.log("Counts >>>>> "+this.teacherCount+" : "+this.studentCount+" : "+this.adminCount);
      });
   
  }
  groupObj(array, key){
    var result=_.chain(array).groupBy(key).map(function(v, i) {
      return {
        name: i,    
        values: _.map(v, 'name')
      }
    }).value();
    return result;
   }



  removeDuplicates( arr, key) { 
      
    // Create an array of objects 
   
    // Display the list of array objects 
    //console.log("array >>>> "+arr); 

    // Declare a new array 
    let newArray = []; 
      
    // Declare an empty object 
    let uniqueObject = {}; 
      
    // Loop for the array elements 
    for (let i in arr) { 

        // Extract the title 
        let objTitle = arr[i][key]; 

        // Use the title as the index 
        uniqueObject[objTitle] = arr[i]; 
    } 
      
    // Loop to push unique object into array 
    for (let i in uniqueObject) { 
        newArray.push(uniqueObject[i]); 
    } 
      
    // Display the unique objects 
    //console.log("newArray >>>> "+JSON.stringify(newArray)); 
    return newArray;
} 
  // getUserTypeList(filter) {}
  // getGenderWiseUserList(filter) {}

  exportData(currenttab: any) {
    if (currenttab === 'overview') {

    }
    if (currenttab === 'users') {
      this.userUsageDataService.userUsage$Data.subscribe(data => {
        let csv = new Array();
        csv.push('Users Usage Data');
        csv.push('');
        csv = csv.concat(this._objectArrayToCsv(data));
        csv.push('');
        this._downloadFile(currenttab, csv);
      });
    }
    if (currenttab === 'devices') {
      this.deviceUsageDataService.deviceUsage$Data.subscribe(data => {
        let csv = new Array();
        csv.push('Devices Usage Data');
        csv.push('');
        csv = csv.concat(this._objectArrayToCsv(data));
        csv.push('');
        this._downloadFile(currenttab, csv);
      });
    }
    if (currenttab === 'applications') {
      this.applicationUsageDataService.applicationUsage$Data.subscribe(data => {
        let csv = new Array();
        csv.push('Applications Usage Data');
        csv.push('');
        csv = csv.concat(this._objectArrayToCsv(data));
        csv.push('');
        this._downloadFile(currenttab, csv);
      });
    }
    if (currenttab === 'content') {
      this.contentUsageDataService.contentUsage$Data.subscribe(data => {
        let csv = new Array();
        csv.push('Contents Usage Data');
        csv.push('');
        csv = csv.concat(this._objectArrayToCsv(data));
        csv.push('');
        this._downloadFile(currenttab, csv);
      });
    }
  }

  _downloadFile(currenttab, csv) {
    let csvArray = csv.join('\r\n');
    var blob = new Blob([csvArray], {type: 'text/csv' })
    saveAs(blob, currenttab + ".csv");
  }

  _objectArrayToCsv(data: any) {
    const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    let header = Object.keys(data[0]);
    let csv = data.map(
      row => header.map(fieldName => {
        if (fieldName === 'role') {
          return JSON.stringify(row['role']['name'], replacer)
        }
        else {
          return JSON.stringify(row[fieldName], replacer)
        }
      }
      ).join(','));
    csv.unshift(header.join(','));
    return csv;
  }
}
